import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import PromotionBox, {
  CtaDesigns,
} from 'src/components/HomePromotionsStack/PromotionBox/PromotionBox'
import SvgBudgetUnselected from 'src/components/Svgs/SvgBudgetUnselected'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import { useTranslate } from 'src/localization/Trns'
import { registerAccountUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

interface RegisterAccountOnboardingPromotionBoxProps {
  className?: string
  ctaDesign: CtaDesigns
  isHome?: boolean
  isHighlighted?: boolean
}

const RegisterAccountOnboardingPromotionBox: React.FC<
  RegisterAccountOnboardingPromotionBoxProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  const accountsImage = useColorOrGrayscaleImage(ImageNames.Accounts)
  return (
    <PromotionBox
      className={props.className}
      imageSrc={accountsImage}
      id="setUpAccountPromoBox"
      title={
        props.isHome
          ? translate('Set up your account')
          : translate('Add an account')
      }
      subtitle={
        props.isHome
          ? translate(
              'Register your company credit card account so you can start sending virtual cards.',
            )
          : translate('Register a credit card account to create virtual cards.')
      }
      ctaProps={{
        ctaDesign: props.ctaDesign,
        ctaContent: (
          <div
            id="regAccFirstTime"
            css={css`
              display: flex;
              align-items: center;
            `}
          >
            <SvgBudgetUnselected
              css={css`
                transform: scale(calc(18 / 24));
                transform-origin: left;
                path {
                  fill: ${styleConstants.colors.white};
                }

                ${getBreakpointDown(breakpointSizes.XSM)(css`
                  display: none;
                `)}
              `}
            />
            {translate('Register an account')}
          </div>
        ),
        ctaTo: registerAccountUrl(),
        ctaAriaLabelSource: 'Register an account',
      }}
    />
  )
}

export default RegisterAccountOnboardingPromotionBox
